define.alias("ember-math-helpers/helpers/sign", "settings/helpers/sign");